import { API_ENDPOINT } from "@/constants/appConstants";
import { getHttpMethod } from "@/helpers/getHttpMethod";
import { useProfileSectionData } from "@/hooks";
import {
  HEADER_QUERY_KEY,
  PROFILE_QUERY_KEY,
  PROFILE_STATS_QUERY_KEY,
  VALIDATE_PROFILE_QUERY_KEY,
} from "@/lib/queryKeys";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ActionType, ErrorResponse } from "@/components/profile/types";

import { PersonalData } from "./types";

export const getPersonal = () => {
  return useProfileSectionData<PersonalData>("personalDetailSection");
};

export const useUpdatePersonal = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ data, action }: { data: any; action: ActionType }) => {
      const method = getHttpMethod(action);
      const response = await fetch(
        API_ENDPOINT(window.location.host).middleware.personalDetails,
        {
          method,
          body: JSON.stringify(data),
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
        },
      );

      if (!response.ok) {
        const errorData = (await response.json()) as ErrorResponse;
        throw new Error(
          errorData.error.message.errorMessage || "Something went wrong",
        );
      }

      return await response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [HEADER_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [PROFILE_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [PROFILE_STATS_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [VALIDATE_PROFILE_QUERY_KEY] });
    },
  });
};
